<template>
  <div
    class="invoice-surcharge-container"
    v-for="(surcharge, index) in totalSelectedSurchargeItems"
    :key="`surcharge_${index}`"
  >
    <div class="invoice-surcharge-row">
      <div>
        {{ setSurchargeLabel(surcharge) }}
      </div>
      <div>
        {{ formatSurcharge(surcharge) }}
        <InvoiceItemMenu
          @on-edit="onEdit(surcharge, index)"
          @on-delete="onDelete(surcharge)"
        />
      </div>
    </div>
  </div>
  <NrModal
    :show="activeSurchargeDeleteModal"
    primaryButtonText="Delete fee/discount"
    secondaryButtonText="Cancel"
    title="Delete fee/discount"
    hasSecondaryButton
    @on-primary-click="deleteInvoiceSurchargeItem"
    @on-secondary-click="setActiveModal('')"
    @on-close-click="setActiveModal('')"
  >
    <p>
      Are you sure you want to remove
      {{ this.invoiceItemToEdit?.label }} from the list?
    </p>
  </NrModal>
</template>

<script lang="ts">
import NrModal from '@nextrequestco/components/src/components/NrModal'
import { SurchargeOption } from '../types/invoice_line_items'
import InvoiceItemMenu from './InvoiceItemMenu.vue'
import helpers from '../../../../../utils/helpers.js'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  components: {
    InvoiceItemMenu,
    NrModal
  },

  computed: {
    ...mapState('request_show', [
      'totalSelectedSurchargeItems',
      'activeModal',
      'subtotalInvoiceAmount',
      'invoiceItemToEdit'
    ]),

    activeSurchargeDeleteModal() {
      return this.activeModal === 'deleteInvoiceSurcharge'
    }
  },

  methods: {
    ...mapActions('request_show', ['recalculateAllCosts']),

    ...mapMutations('request_show', [
      'setInvoiceLineItemType',
      'setInvoiceSelectedSurchargeItem',
      'setInvoiceAddItemModal',
      'setTotalSelectedSurchargeItems',
      'setInvoiceItemToEdit',
      'setActiveModal'
    ]),

    formatCost(amount: number) {
      return helpers.formatCost(amount)
    },

    formatSurcharge(surcharge: SurchargeOption): number {
      const amount = surcharge?.amount
      return surcharge.cost_type === 'percentage'
        ? this.formatCost(
            (parseFloat(amount) / 100) * this.subtotalInvoiceAmount
          )
        : this.formatCost(Number(amount))
    },

    setSurchargeLabel(surcharge: SurchargeOption): string {
      return surcharge.cost_type === 'percentage'
        ? `${surcharge?.label} (${surcharge?.amount}%)`
        : `${surcharge?.label}`
    },

    onEdit(surcharge: SurchargeOption, index: number): void {
      const item = { ...surcharge, index }
      this.setInvoiceItemToEdit(item)
      this.setInvoiceLineItemType('Fee or discount')
      this.setInvoiceSelectedSurchargeItem(surcharge)
      this.setInvoiceAddItemModal(true)
    },

    onDelete(surcharge: SurchargeOption): void {
      this.setInvoiceItemToEdit(surcharge)
      this.setActiveModal('deleteInvoiceSurcharge')
    },

    deleteInvoiceSurchargeItem(): void {
      const newSurchargeItems = this.totalSelectedSurchargeItems.filter(
        (i: SurchargeOption) => i.value !== this.invoiceItemToEdit?.value
      )
      this.setTotalSelectedSurchargeItems(newSurchargeItems)
      this.recalculateAllCosts()
      this.setActiveModal('')
    }
  }
}
</script>

<style lang="scss"></style>
